import React, { Component } from 'react';
import {Link} from 'react-router-dom'
class BottomBar extends Component {
    render() {
        return (
            <div className="footer-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="copyright">
                                    <p>Copyright 2026 Stats Elites.</p>
                                </div>
                                <ul className="menu-footer">
                                    <li><Link to="/" title="">Home</Link></li>
                                    <li><Link to="/blog" title="">My Blog</Link></li>
                                    <li><Link to="/" title="">My Home</Link></li>
                                </ul>
                                {/* <!-- /.menu-footer --> */}
                            </div>
                        </div>
                    </div>
                </div>
                /* <!-- /.footer-bottom --> */
        );
    }
}

export default BottomBar;
